import { render, staticRenderFns } from "./leaveBill.vue?vue&type=template&id=af49fb8c&scoped=true&"
import script from "./leaveBill.vue?vue&type=script&lang=js&"
export * from "./leaveBill.vue?vue&type=script&lang=js&"
import style0 from "./leaveBill.vue?vue&type=style&index=0&id=af49fb8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af49fb8c",
  null
  
)

export default component.exports